<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="8.606" height="9.534" viewBox="0 0 8.606 9.534">
		<g id="Group_29957" data-name="Group 29957" transform="translate(0.652 0.6)">
			<g id="b">
				<g id="c" transform="translate(0 0)">
					<g id="Group_29576" data-name="Group 29576">
						<path
							id="d"
							d="M9.4,1.762a1.285,1.285,0,0,1,0-.226A1.143,1.143,0,0,0,8.18.49H5.75V8.818h2"
							transform="translate(-2.102 -0.484)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-miterlimit="10"
							stroke-width="1.2"
						/>
						<path
							id="e"
							d="M2.132,8.815h2V.481H1.706A1.147,1.147,0,0,0,.481,1.526a1.285,1.285,0,0,1,0,.226"
							transform="translate(-0.481 -0.481)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-miterlimit="10"
							stroke-width="1.2"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TextIndicatorSVG',
};
</script>

<style scoped lang="scss"></style>
